/*

 */

export const GENERAL_LOADER_FAUX_RESOURCE_TYPE = 'general_loader';